import { Tracking } from './Tracking';

export enum EntryPoints {
    COINS = 'Coins',
    INVITE = 'Invite',
    REQUEST_GIFT = 'RequestGift',
    SEND_GIFT = 'SendGift',
    XPROMO = 'xPromo',
}

export default class EntryTracking {
    public static track(entry: EntryPoints) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Entry_${entry}`,
        });
    }

    public static allXPromo(originGameId: string, reward: boolean, isNewPlayer: boolean = false) {
        Tracking.addTrack({
            eventName: 'Entries_xPromo',
            valueToSum: 1,
            params: {
                source: originGameId,
                reward,
            },
        });

        const playerEventName = isNewPlayer ? 'XPromo_new_user' : 'XPromo_old_user';
        Tracking.addTrack({
            eventName: playerEventName,
            valueToSum: 1,
            params: {
                source: originGameId,
                reward,
            },
        });
    }
}
